
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vault-lottery",
      function () {
        return require("private-next-pages/vault-lottery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vault-lottery"])
      });
    }
  